export default __webpack_public_path__ + "static/media/lil-loading-skull.b7a846e1.gif";